import { render, staticRenderFns } from "./CreateCampaignType.vue?vue&type=template&id=3db31af6&scoped=true"
import script from "./CreateCampaignType.vue?vue&type=script&lang=js"
export * from "./CreateCampaignType.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignType.vue?vue&type=style&index=0&id=3db31af6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db31af6",
  null
  
)

export default component.exports